module.exports = __webpack_public_path__ + "img/dmk_chibi-job_bnr.34eac75e.png";